module.exports = __webpack_public_path__ + "static/media/speaker-pre-record.4f5b7bc4.png";